"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { createRef, forwardRef } from "react";
import { createPortal } from "react-dom";
import { Transition } from "react-transition-group";
import observeRect from "@reach/observe-rect";
import getPortalRoot from "../../../utils/getPortalRoot";
import IconButton from "../IconButton/IconButton";
import forceReflow from "../../../utils/forceReflow";
import { Observer, observer } from "mobx-react";
import { action, computed, observable } from "mobx";
import classNames from "classnames";
import { Layer } from "../../..";
import { darkTheme } from "../../../tokens/tokens-css";
import * as styles from "./Toolbar-css";
import { assignInlineVars } from "@vanilla-extract/dynamic";
export var ToolbarPositionType = /* @__PURE__ */ ((ToolbarPositionType2) => {
  ToolbarPositionType2["Element"] = "element";
  ToolbarPositionType2["None"] = "none";
  return ToolbarPositionType2;
})(ToolbarPositionType || {});
const isElementBasedAutoposition = (props) => {
  return props.positionType === "element" /* Element */;
};
const elementBasedPropsChanged = (props, prevProps) => {
  return props.element === prevProps.element && props.offset === prevProps.offset && props.visible === prevProps.visible;
};
let Toolbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.position = { x: 0, y: 0 };
    this.toolbarRef = createRef();
    this.setUpElementBasedAutoposition = () => {
      var _a;
      if (!isElementBasedAutoposition(this.props)) {
        return;
      }
      if (this.elementRectObserver) {
        this.elementRectObserver.unobserve();
      }
      if (!this.props.element || !this.props.visible) {
        return;
      }
      const offset = (_a = this.props.offset) != null ? _a : 16;
      this.elementRectObserver = observeRect(this.props.element, (rect) => {
        var _a2;
        const toolbarRect = (_a2 = this.toolbarRef.current) == null ? void 0 : _a2.getBoundingClientRect();
        if (!toolbarRect) {
          return;
        }
        const x = rect.left + rect.width / 2 - toolbarRect.width / 2;
        const y = rect.top - (toolbarRect == null ? void 0 : toolbarRect.height) - offset;
        this.setPosition({ x, y });
      });
      this.elementRectObserver.observe();
    };
    this.setPosition = (newPosition) => {
      this.position = newPosition;
    };
    if (this.shouldUsePortal) {
      this.toolbarPortalRoot = getPortalRoot("toolbar-root");
    }
  }
  componentDidMount() {
    if (isElementBasedAutoposition(this.props)) {
      this.setUpElementBasedAutoposition();
    }
  }
  componentDidUpdate(prevProps) {
    if (isElementBasedAutoposition(this.props) && isElementBasedAutoposition(prevProps) && !elementBasedPropsChanged(this.props, prevProps)) {
      this.setUpElementBasedAutoposition();
    }
  }
  componentWillUnmount() {
    var _a;
    (_a = this.elementRectObserver) == null ? void 0 : _a.unobserve();
  }
  render() {
    const { position, toolbarRef, toolbarPortalRoot } = this;
    const { visible, positionType, children, className, onMouseDown } = this.props;
    const maybeMountInPortal = this.shouldUsePortal && toolbarPortalRoot ? (value) => createPortal(value, toolbarPortalRoot) : (value) => value;
    return /* @__PURE__ */ React.createElement(Layer, null, ({ zIndex }) => /* @__PURE__ */ React.createElement(Transition, { mountOnEnter: true, unmountOnExit: true, in: visible, timeout: 400, onEnter: forceReflow }, (status) => /* @__PURE__ */ React.createElement(Observer, null, () => maybeMountInPortal(
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(
            styles.wrapper({
              manualPosition: positionType === "none" /* None */
            }),
            `kl-toolbar kl-toolbar--${status}`,
            darkTheme,
            className,
            {
              ["kl-toolbar--manual-position"]: positionType === "none" /* None */
            }
          ),
          onMouseDown,
          style: __spreadValues(__spreadValues({}, this.props.autoStack ? { zIndex } : {}), position ? assignInlineVars({
            [styles.toolbarX]: `${Math.round(position.x) || 0}px`,
            [styles.toolbarY]: `${Math.round(position.y) || 0}px`
          }) : {}),
          ref: toolbarRef
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: `kl-toolbar__content kl-toolbar__content--${status} ${styles.content({ status })}`
          },
          children
        )
      )
    ))));
  }
  get shouldUsePortal() {
    return this.props.positionType !== "none" /* None */;
  }
};
__decorateClass([
  observable.ref
], Toolbar.prototype, "position", 2);
__decorateClass([
  action
], Toolbar.prototype, "setPosition", 2);
__decorateClass([
  computed
], Toolbar.prototype, "shouldUsePortal", 1);
Toolbar = __decorateClass([
  observer
], Toolbar);
export {
  Toolbar as default
};
const ToolbarButton = forwardRef((_a, ref) => {
  var _b = _a, { onClick, selected, icon } = _b, props = __objRest(_b, ["onClick", "selected", "icon"]);
  const handleClick = (event) => {
    event.stopPropagation();
    onClick == null ? void 0 : onClick(event);
  };
  return /* @__PURE__ */ React.createElement(
    IconButton,
    __spreadValues({
      ref,
      icon,
      className: `kl-toolbar__button ${styles.button}`,
      "aria-pressed": selected,
      onClick: handleClick
    }, props)
  );
});
const ToolbarSeparator = () => {
  return /* @__PURE__ */ React.createElement("div", { className: `kl-toolbar__separator ${styles.separator}`, role: "separator" });
};
export { ToolbarButton, ToolbarSeparator };
